export var LoadState;
(function (LoadState) {
    LoadState[LoadState["NotLoading"] = 0] = "NotLoading";
    LoadState[LoadState["Loading"] = 1] = "Loading";
    LoadState[LoadState["Loaded"] = 2] = "Loaded";
})(LoadState || (LoadState = {}));
//# sourceMappingURL=LoadState.js.map